import React from 'react';
import { connect } from 'react-redux';
import { BaseDialog } from '../layout/Dialog';
import { showDialog } from '../../actions/dialog';
import './DownloadPdfCsvDialog.css';
import { PulseLoader } from 'react-spinners';
import { CreatorReportAnalytics } from '../../analytics/CreatorReportAnalytics';
import { popFileFetch } from '../../services/pop-file-fetch';

class DownloadPdfCsvDialog extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      hideCsv: false,
      centerCsv: false,
      hidePdf: false,
      centerPdf: false,
      loading: false,
      progress: 0,
      increment: null,
      currentPopin: 0
    };
  }

  incrementCurrentPopin = () => {
    if (this.state.collection && this.state.currentPopin < this.state.collection.events.length) {
    }
    this.setState({
      currentPopin: this.state.currentPopin + 1
    });
  };

  onDialogHidden = () => {
    const { toggleDialog } = this.props;
    toggleDialog();
  };

  hidePdf = () => {
    this.setState({ hidePdf: true });
    this.setState({ centerCsv: true });
    this.setState({ loading: true });
  };

  hideCsv = () => {
    this.setState({ hideCsv: true });
    this.setState({ centerPdf: true });
    this.setState({ loading: true });
  };

  updateProgressBar = (increment, currentPopin, totalPopins) => {
    this.setState({
      progress: this.state.progress + increment,
      currentPopin: currentPopin,
      totalPopins: totalPopins
    });
  };

  getButtonText = (showOkButton) => {
    if (!!showOkButton) {
      return 'Ok';
    } else {
      return 'Cancel';
    }
  };

  render () {
    const { handlePdfGeneration, event, collection, toggleDialog } = this.props;
    // TODO Don't access the Api in the view layer directly
    return (
      <BaseDialog
        show={ true }
        closeOnEscape={ false }
        closeOnClickOutside={false}
        customModalDialogClass="download-pdf-csv-dialog"
        customModalBodyClass="download-pdf-csv-body"
        body={
          <div className="row no-gutters">
            <div className="col">
              <div
                className="text-center"
                style={ { visibility: `${this.state.loading ? 'hidden' : 'visible'}` } }>
                Choose a format
              </div>
              <br />
              <div className="row justify-content-center">
                <DownloadPdf
                  handlePdfGeneration={ handlePdfGeneration } // we need to create the download link first, by calling the generatePdf saga
                  event={ event }
                  toggleDialog={ toggleDialog }
                  updateProgressBar={ this.updateProgressBar }
                  currentPopin={ this.state.currentPopin }
                  totalPopins={ this.state.totalPopins }
                  incrementCurrentPopin={ this.incrementCurrentPopin }
                  moreThanOne={ !!collection }
                  hideCsv={ this.hideCsv }
                  center={ this.state.centerPdf }
                  hide={ this.state.hidePdf } />
                <DownloadCsv
                  event={ event }
                  collection={ collection }
                  toggleDialog={ toggleDialog }
                  hidePdf={ this.hidePdf }
                  center={ this.state.centerCsv }
                  hide={ this.state.hideCsv } />
              </div>
            </div>
          </div>
        }
        cancel={!this.state.loading ? 'cancel' : null}
        onCancel={ () => {
          CreatorReportAnalytics.exportReportModalClosed('cancel');
        } }
        hideDialog={ this.onDialogHidden }
        onCloseOnClickOutside={ () => {
          CreatorReportAnalytics.exportReportModalClosed('outside click');
        } }
      />
    );
  }
}

class DownloadPdf extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  handleClick = () => {
    const { event, handlePdfGeneration, hideCsv, updateProgressBar, incrementCurrentPopin } = this.props;
    // Start the PDF zip generation process
    handlePdfGeneration(event, updateProgressBar, incrementCurrentPopin);
    hideCsv();
    this.setState({ loading: true });
    CreatorReportAnalytics.exportReport('Export PDF');
  };

  render () {
    const { hide, center, currentPopin, totalPopins } = this.props;
    const { loading } = this.state;
    return (
      <div
        className={ `download-item px-2 ${hide ? 'hide ' : ' '}${center ? 'shift-right' : ''}` }
        onClick={ this.handleClick }>
        <div className="h-100 m-auto download-stuff">
          { loading
            ? <PulseLoader color="#3D9AE2" size={ 10 } />
            : (
              <i className="material-icons">insert_chart</i>
            )
          }
          <div className="font-size-xs display-if-medium download-stuff">
            { loading
              ? <span className="">{ currentPopin === 0
                ? 'Generating reports...'
                : `Finishing PDF ${currentPopin} of ${totalPopins}` }</span>
              : 'Download PDF' }
          </div>
        </div>
      </div>
    );
  }
}

class DownloadCsv extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  downloadCsv = (url) => {
    // window.open(url, '_self');
    // Force Download (Safari Fix)
    // Create a hidden <a> element when Clicked.
    const downloadOnTheSpot = document.createElement('a');
    downloadOnTheSpot.setAttribute('href', url);
    downloadOnTheSpot.setAttribute('download', 'report.csv');
    downloadOnTheSpot.style.display = 'none';
    // Append hidden <a> tag.
    document.body.appendChild(downloadOnTheSpot);
    // Make <a> tag clicked.
    downloadOnTheSpot.click();
    // Then Remove <a> tag.
    document.body.removeChild(downloadOnTheSpot);
  };

  handleClick = () => {
    const { toggleDialog, hidePdf, event, collection } = this.props;
    // Flip loading to true to start spinner
    this.setState({ loading: true }, () => {
      hidePdf();
      // Fake out the CSV generation by spinning for a few seconds
      window.setTimeout(() => {
        const url = popFileFetch.csv(event, collection);
        this.downloadCsv(url);
        toggleDialog();
        this.setState({ loading: false });
      }, 3000);
    });

    CreatorReportAnalytics.exportReportModalClosed('Export CSV');
  };

  render () {
    const { hide, center } = this.props;
    return (
      <div
        className={ `download-item px-2 ${hide ? 'hide ' : ' '}${center ? 'shift-left' : ''}` }
        onClick={ this.handleClick }>
        <div className="h-100 m-auto">
          { this.state.loading
            ? <PulseLoader color="#3D9AE2" size={ 10 } />
            : (
              <i className="material-icons">insert_drive_file</i>
            )
          }
          <div className="font-size-xs display-if-medium">
            { this.state.loading
              ? 'Generating CSV...'
              : 'Download CSV' }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    pdfLoading: state.pdf.loading,
    pdfError: state.pdf.error,
    pdfDownloadUrl: state.pdf.pdfDownloadUrl
  };
};

export default connect(mapStateToProps, {
  showDialog
})(DownloadPdfCsvDialog);
